var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100"},[(!_vm.disabled)?_c('input',{ref:"input",staticClass:"borderless w-100",attrs:{"id":_vm.id,"autocomplete":"new-password","placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value}}):_c('p',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }